export default {"src":"/_next/static/media/process-tracking-active.d4557eea.svg","height":3,"width":318,"blurWidth":0,"blurHeight":0};